import { render } from "./ModifyLight.vue?vue&type=template&id=62b44414"
import script from "./ModifyLight.vue?vue&type=script&lang=js"
export * from "./ModifyLight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__